import { render, staticRenderFns } from "./Transporteur.vue?vue&type=template&id=2ed0c858&"
import script from "./Transporteur.vue?vue&type=script&lang=ts&"
export * from "./Transporteur.vue?vue&type=script&lang=ts&"
import style0 from "./Transporteur.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports